import React, { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { FincaraizHeaderMenu } from "./FincaraizHeaderMenu";
import { isInfoCasasTheme } from "./brandTheme";

type HeaderMenuProps = {
	type: "desktop" | "mobile";
};

export const HeaderMenu = ({ type = "desktop" }: HeaderMenuProps) => {
	const { header_links, country_code } = useContext(ConfigStateContext);
	const isInfoCasas = isInfoCasasTheme();

	if (country_code === "CO") {
		return <FincaraizHeaderMenu type={type} />;
	}

	const navClass = type == "desktop" ? "header_desktop_menu" : "header_mobile_menu";
	const linkClass = type == "desktop" ? "header_btn" : "header_btn_mobile";
	const brandClass = isInfoCasas ? " header_menu--ic" : "";

	return (
		<nav className={`${navClass}${brandClass}`}>
			{header_links?.map(({ link, title }, i) => {
				return (
					<a className={`${linkClass} ${country_code}`} href={link} key={`headerMenu-${i}`}>
						{title}
					</a>
				)
			})}
		</nav>
	);
};
